import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, FileText, Package, Wrench } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ContaDashboard() {
    const { user } = useAuth();
    const firstName = (user?.name || "").split(" ")[0] || "Bem-vindo";

    return (
        <div data-testid="conta-dashboard">
            {/* Welcome card */}
            <div className="rounded-2xl border border-border bg-gradient-to-br from-primary to-primary/90 text-white p-6 sm:p-8 relative overflow-hidden">
                <div aria-hidden className="absolute -top-24 -right-24 h-80 w-80 rounded-full opacity-20 pointer-events-none" style={{ background: "radial-gradient(circle, #FBBF24 0%, transparent 60%)" }} />
                <span className="inline-flex items-center gap-1 rounded-full bg-secondary/90 text-primary px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em]">
                    <Sparkles className="h-3 w-3" /> Painel do cliente
                </span>
                <h1 className="mt-4 font-heading text-4xl font-extrabold leading-tight">Olá, {firstName} 👋</h1>
                <p className="mt-2 text-white/75 max-w-xl">
                    Aqui pode consultar os seus pedidos de orçamento, gerir os equipamentos adquiridos
                    e abrir pedidos de assistência ou garantia.
                </p>
                <Link to="/simulador" data-testid="dashboard-new-request"
                    className="mt-6 inline-flex items-center gap-2 rounded-md bg-secondary px-5 py-3 text-sm font-bold text-primary hover:-translate-y-0.5 transition">
                    Fazer um novo pedido <ArrowRight className="h-4 w-4" />
                </Link>
            </div>

            {/* Section cards */}
            <div className="mt-8 grid gap-4 md:grid-cols-3">
                <SectionCard to="/conta/pedidos" icon={FileText} title="Os meus pedidos" hint="Histórico das configurações submetidas no simulador." testId="card-pedidos" />
                <SectionCard to="/conta/equipamentos" icon={Package} title="Os meus equipamentos" hint="Carrinhos comprados, nº de série, fim de garantia." testId="card-equipamentos" />
                <SectionCard to="/conta/assistencia" icon={Wrench} title="Assistência técnica" hint="Abrir pedido de garantia ou manutenção." testId="card-assistencia" />
            </div>

            <p className="mt-8 text-xs text-muted-foreground">
                💡 Ainda não há dados aqui? É normal — o seu histórico aparece assim que submeter pedidos ou o administrador
                registar os seus equipamentos adquiridos.
            </p>
        </div>
    );
}

function SectionCard({ to, icon: Icon, title, hint, testId }) {
    return (
        <Link to={to} data-testid={testId}
            className="group block rounded-2xl border border-border bg-white p-6 transition hover:-translate-y-1 hover:shadow-lg hover:border-primary/30">
            <div className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-secondary/50 text-primary">
                <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-4 font-heading text-xl font-extrabold text-primary">{title}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{hint}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-bold text-primary opacity-60 group-hover:opacity-100 group-hover:gap-2 transition-all">
                Abrir <ArrowRight className="h-3 w-3" />
            </span>
        </Link>
    );
}
